import { render, staticRenderFns } from "./bindwx.vue?vue&type=template&id=54fbbe16&scoped=true&"
import script from "./bindwx.vue?vue&type=script&lang=js&"
export * from "./bindwx.vue?vue&type=script&lang=js&"
import style0 from "./bindwx.vue?vue&type=style&index=0&id=54fbbe16&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./bindwx.vue?vue&type=style&index=1&id=54fbbe16&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbbe16",
  null
  
)

export default component.exports